import { Api } from 'utils';

interface HomeAdminParams {
	since?: string;
	until?: string;
	period?: 'today' | 'week' | 'month' | 'year' | 'all' | 'custom';
	chart_granularity?: 'day' | 'week' | 'biweek' | 'month';
	withoutLoading?: boolean;
}

interface UsersDetailParams {
	type: string;
	since?: string;
	until?: string;
	withoutLoading?: boolean;
}

class HomeService {

	static admin = {
		get: async (params?: HomeAdminParams) => Api.createResponse('admin/home',params),
		getUsersDetail: async (params?: UsersDetailParams) => Api.createResponse('admin/home/users-detail',params),
	}

}

export default HomeService;